import Users from "@/services/Users";

export default {
  methods: {
    /**
     * Get Vuex Store Customer Id
     * @returns {Integer}
     */
    getCustomerId() {
      if (this.$store.state.auth)
        return JSON.parse(this.$store.state.auth).customer_id;
      return false;
    },

    /**
     * Get Vuex Store HCR User Id
     * @returns {Integer}
     */
    getHcrUserId() {
      if (this.$store.state.auth)
        return JSON.parse(this.$store.state.auth).hcr_user_id;
      return false;
    },

    getAuthObject() {
      return JSON.parse(this.$store.state.auth);
    },

    setCustomerInAuth( customer_id ) {
      let authData = this.getAuthObject();
      authData.customer_id = customer_id;
      this.$store.commit('auth', JSON.stringify(authData));
      localStorage.customer_id = JSON.stringify(authData);
    },

    isCartSet() {
      return this.$store.state.cart.length > 0;
    },

    isCartEmpty() {
      return this.$store.state.cart.length == 0;
    },

    isTrainingCourse() {
      return localStorage.getItem("trainingCourse") != null;
    },

    redirectTo( path  ) {
        this.$router.replace( path );
    },

    /**
     * Check Countries data in Local Storage
     * @returns {Boolean}
     */
    checkCountriesInLocalStorage() {
      return window.localStorage.getItem('countries') ? true : false;
    },

    /**
     * Get countries list from localStorage
     * @returns {Object}
     */
    getCountriesFromLocalStorage(){
      return this.checkCountriesInLocalStorage()
                ? JSON.parse(window.localStorage.getItem('countries')) 
                : {};
    },

    /**
     * Get countries list from db
     * @returns {Promise}
     */
    fetchCountries(){
      return Users.getcountry()
        .then(response => {
          return response;
        })
        .catch(error => {
          this.showFlashMessage();
        });
    },

    mountScriptToHead( srcPath, id ) {
      let scriptElement = document.createElement("script");
      scriptElement.setAttribute( "src", srcPath );
      scriptElement.setAttribute( "id", id );
      document.head.appendChild(scriptElement);
    },

    showFlashMessage( msg, type, timeout ) {
      msg       = ( msg === "" || typeof msg === 'undefined' ) ? "You are offline connect to network." : msg;
      type      = ( type === "" || typeof type === 'undefined' ) ? "info" : type;
      timeout   = ( timeout > 0 || typeof timeout !== 'undefined' ) ? timeout : 2000;
      
      this.flash(msg, type, { timeout: timeout });
    },

    /**
     * Check if string is JSON parsable 
     * @param {Object} str 
     * @returns {Boolean}
     */
    isJson(str) {
      try {
        JSON.parse(str);
      } catch (e) {
        return false;
      }
      return true;
    },

    isEmptyObject( jsonObject ){
      return JSON.stringify( jsonObject ) === JSON.stringify({});
    }
  },
  computed: {
    localTelNo(){
      return (this.$store.state.contactInfo.telephones) ? JSON.parse(this.$store.state.contactInfo.telephones).local_number : "";
    }, 
    internationalTelNo(){
      return (this.$store.state.contactInfo.telephones) ? JSON.parse(this.$store.state.contactInfo.telephones).international_number : "";
    },
    faxNo(){
      return (this.$store.state.contactInfo.telephones) ? JSON.parse(this.$store.state.contactInfo.telephones).fax_number : "";
    }
  },
}